import { Gift01 } from "@untitledui/icons";
import { IconChip, cx, formatTomanRound } from "@mfa-aff/ui";
import { useMe } from "../../api/me";

/**
 * «پاداش اولین فروش» as a promise (review 2026-10-07): shown until the partner's first sale is
 * approved. The server decides (`/me.onboarding.firstSaleBonusRial`, null = nothing to promise).
 * `compact`: one line inside another card (the getting-started checklist).
 */
export const FirstSaleBonusPromise = ({ compact = false, className }: { compact?: boolean; className?: string }) => {
    const { data: me } = useMe();
    const rial = me?.onboarding.firstSaleBonusRial ?? null;
    if (!rial) return null;
    const amount = formatTomanRound(rial);

    if (compact) {
        return (
            <p className={cx("flex items-center gap-2 text-sm font-medium text-success-primary", className)}>
                <Gift01 className="size-5 shrink-0" aria-hidden="true" />
                با اولین فروش تأییدشده {amount} هدیه می‌گیرید.
            </p>
        );
    }
    return (
        <div className={cx("flex items-start gap-3 rounded-2xl bg-success-primary p-4 ring-1 ring-utility-green-200 ring-inset dark:bg-accent-500/10 dark:ring-accent-500/25 md:p-5", className)}>
            <IconChip icon={Gift01} color="success" />
            <div className="flex min-w-0 flex-col gap-1">
                <p className="text-md font-semibold text-primary">با اولین فروش تأییدشده {amount} هدیه</p>
                <p className="text-sm text-tertiary">
                    وقتی اولین فروش شما از دورهٔ ضمانت گذشت، این مبلغ یک‌بار به کیف پول حساب میزبان‌فای شما واریز می‌شود و با آن می‌توانید سرویس بخرید یا تمدید کنید.
                    فروشی که خودتان برای خودتان بخرید یا برگشت بخورد، حساب نمی‌شود.
                </p>
            </div>
        </div>
    );
};
